// ---------------------------------------- Building control quotation
/* Building inspection company list */
export interface BuildingInspectionCompany {
    id: number;
    country_id: number;
    company_name: string;
    email: string;
    reg_no: string | null;
    landline_no: string | null;
    address: string | null;
    post_code: string | null;
    city: string | null;
    status: 1 | 0;
}

export const mapBuildingInspectionCompany = (data: any): BuildingInspectionCompany => {
    if (!data) {
        throw new Error("Invalid building inspection company type");
    }

    const buildingInspectionCompany: BuildingInspectionCompany = {
        id: data.id,
        country_id: data.country_id,
        company_name: data.company_name,
        email: data.email,
        reg_no: data.reg_no ?? null,
        landline_no: data.landline_no ?? null,
        address: data.address ?? null,
        post_code: data.post_code ?? null,
        city: data.city ?? null,
        status: data.status,
    };

    return buildingInspectionCompany;
};

export const mapBuildingInspectionCompanies = (data: any[]): BuildingInspectionCompany[] => {
    if (!Array.isArray(data)) {
        throw new Error("Invalid building inspection companies data");
    }

    return data.map(mapBuildingInspectionCompany);
};


/* Building control quotation */
export interface BuildingControlQuotation {
    id: number;
    project_id: number;
    project_name: string;
    project_address: string;
    post_code: string | null;
    city: string | null;
    status: string;
    area_id: number | null;
    quotation_share_list: BuildingControlQuotationShareList[];
}

export const mapBuildingControlQuotation = (data: any): BuildingControlQuotation => {
    if (!data) {
        throw new Error("Invalid building control quotation type");
    }

    const buildingControlQuotation: BuildingControlQuotation = {
        id: data.id,
        project_id: data.project_id,
        project_name: data.project_name,
        project_address: data.project_address,
        post_code: data.post_code ?? null,
        city: data.city ?? null,
        status: data.status,
        area_id: data.area_id ?? null,
        quotation_share_list: Array.isArray(data.quotation_share_list) ? mapBuildingControlQuotationShareLists(data.quotation_share_list) : [],
    };

    return buildingControlQuotation;
};

export const mapBuildingControlQuotations = (data: any[]): BuildingControlQuotation[] => {
    if (!Array.isArray(data)) {
        throw new Error("Invalid building control quotation data");
    }

    return data.map(mapBuildingControlQuotation);
};

/* Building control quotation share list */
export interface BuildingControlQuotationShareList {
    id: number;
    bc_quotation_id: number;
    company_id: number;
    response_sended: 1 | 0;
    is_approved: 1 | 0;
    respone_data: BuildingControlQuotationRequestData | null;
    company: BuildingInspectionCompany | null;
}

export const mapBuildingControlQuotationShareList = (data: any): BuildingControlQuotationShareList => {
    if (!data) {
        throw new Error("Invalid building control quotation share list type");
    }

    const buildingControlQuotationShareList: BuildingControlQuotationShareList = {
        id: data.id,
        bc_quotation_id: data.bc_quotation_id,
        company_id: data.company_id,
        response_sended: data.response_sended,
        is_approved: data.is_approved,
        respone_data: data.respone_data ? mapBuildingControlQuotationRequestData(data.respone_data) : null,
        company: data.company ? mapBuildingInspectionCompany(data.company) : null,
    };

    return buildingControlQuotationShareList;
};

export const mapBuildingControlQuotationShareLists = (data: any[]): BuildingControlQuotationShareList[] => {
    if (!Array.isArray(data)) {
        throw new Error("Invalid building control quotation share list data");
    }

    return data.map(mapBuildingControlQuotationShareList);
};

/* Building control quotation request */
export interface BuildingControlQuotationRequest {
    id: number;
    project_id: number;
    folder_id: number;
    project_name: string;
    project_address: string;
    post_code: string | null;
    city: string | null;
    status: string;
    area_id: number | null;
    responce_data: BuildingControlQuotationRequestData | null;
}

export const mapBuildingControlQuotationRequest = (data: any): BuildingControlQuotationRequest => {
    if (!data) {
        throw new Error("Invalid building control quotation request type");
    }

    const buildingControlQuotationRequest: BuildingControlQuotationRequest = {
        id: data.id,
        project_id: data.project_id,
        folder_id: data.folder_id,
        project_name: data.project_name,
        project_address: data.project_address,
        post_code: data.post_code ?? null,
        city: data.city ?? null,
        status: data.status,
        area_id: data.area_id ?? null,
        responce_data: data.responce_data ? mapBuildingControlQuotationRequestData(data.responce_data) : null,
    };

    return buildingControlQuotationRequest;
};

export const mapBuildingControlQuotationRequests = (data: any[]): BuildingControlQuotationRequest[] => {
    if (!Array.isArray(data)) {
        throw new Error("Invalid building control quotation request data");
    }

    return data.map(mapBuildingControlQuotationRequest);
};

/* Building control quotation request data */
export interface BuildingControlQuotationRequestData {
    id: number;
    bc_quotation_id: number;
    company_id: number;
    reponce: string | null;
    status: 1 | 0;
    sign_report: 1 | 0;
    sign: string | null;
    sign_date: string | null;
    sign_report_by: number | null;
    responce_added_arc: 1 | 0;
    arc_by: number | null
}

export const mapBuildingControlQuotationRequestData = (data: any): BuildingControlQuotationRequestData => {
    if (!data) {
        throw new Error("Invalid building control quotation request data type");
    }

    const buildingControlQuotationRequestData: BuildingControlQuotationRequestData = {
        id: data.id,
        bc_quotation_id: data.bc_quotation_id,
        company_id: data.company_id,
        reponce: data.reponce ?? null,
        status: data.status,
        sign_report: data.sign_report,
        sign: data.sign ?? null,
        sign_date: data.sign_date ?? null,
        sign_report_by: data.sign_report_by ?? null,
        responce_added_arc: data.responce_added_arc,
        arc_by: data.arc_by ?? null
    };

    return buildingControlQuotationRequestData;
};

export const mapBuildingControlQuotationRequestDatas = (data: any[]): BuildingControlQuotationRequestData[] => {
    if (!Array.isArray(data)) {
        throw new Error("Invalid building control quotation request data");
    }

    return data.map(mapBuildingControlQuotationRequestData);
};